import { __assign, __awaiter, __generator } from "tslib";
export var listAllPaginatedRecommendedPageSize = 1000;
/**
 * listAllPaginated returns an array of all the values of a specified property from a given paginated List endpoint.
 *
 * Params:
 * - listFunction: a paginated list function
 * - property: the name of the response property to be listed
 * - request: an object with any request filters (or empty)
 */
export var listAllPaginated = function (listFunction, property, request) { return __awaiter(void 0, void 0, void 0, function () {
    var acc, pageToken, resp, respArr;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                acc = [];
                pageToken = '';
                _a.label = 1;
            case 1: return [4 /*yield*/, listFunction(__assign(__assign({}, request), { pageToken: pageToken, nextPageToken: pageToken }))
                // this type assertion is needed because TS can't figure out that respArr is always an array
            ];
            case 2:
                resp = _a.sent();
                respArr = resp[property];
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                acc = acc.concat(respArr);
                if (isResponsePageToken(resp)) {
                    pageToken = resp.pageToken;
                }
                else {
                    pageToken = resp.nextPageToken;
                }
                _a.label = 3;
            case 3:
                if (pageToken) return [3 /*break*/, 1];
                _a.label = 4;
            case 4: 
            // this type assertion is to guarantee our return type matches the property type from T
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            return [2 /*return*/, acc];
        }
    });
}); };
function isResponsePageToken(resp) {
    return 'pageToken' in resp;
}
